import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useTextEnableLandlineContext } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/pages/TextEnableLandline/context/useTextEnableLandlineContext'
import { EnterAddressCommon } from 'pages/settings/ui/EnterAddressCommon'

export const EnterAddress = observer(() => {
  const { enterNumberStore, enterAddressStore } = useTextEnableLandlineContext()
  const { phone } = enterNumberStore

  useEffect(() => {
    enterAddressStore.init()
  }, [])

  return <EnterAddressCommon phone={phone} enterAddressStore={enterAddressStore} />
})
